import type { EChartsOption } from 'echarts';
import { EChart } from './EChart';

interface SunburstNode {
  name: string;
  value?: number;
  children?: SunburstNode[];
}

interface SunburstChartProps {
  data: SunburstNode[];
  height?: number | string;
  loading?: boolean;
}

export function SunburstChart({ data, height, loading }: SunburstChartProps) {
  const option: EChartsOption = {
    tooltip: { trigger: 'item' },
    series: [{ type: 'sunburst', data, radius: ['0%', '80%'], label: { rotate: 'radial' }, emphasis: { focus: 'ancestor' } }],
  };
  return <EChart option={option} height={height} loading={loading} />;
}
